import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state = {
  conversations: {},
  meta: {
    userLastSeenAt: undefined,
    conversationStatus: undefined,
  },
  uiFlags: {
    allMessagesLoaded: false,
    isFetchingList: false,
    isAgentTyping: false,
    isCreating: false,
  },
  isChatOnLine: {
    isChatOnline: true,
    onLineMassage: 'Hi',
  },
  // timerConversationCalculate: {
  //   alertTimer: 0,
  //   endConversationTimer: 0,
  // },
  IsShowConfirmDialog: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
